import { useFamilies } from '@hooks/useFamilies';
import { Family } from '@interfaces/index';
import { Box, Slide, useScrollTrigger } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { NavigatorContext } from 'provider/Navigator.provider';
import React from 'react';
import styled from 'styled-components';

const AllFamilyItem = {
  uuid: 'all',
  name: 'Todo',
} as any as Family;

export const Header = () => {
  const { families, loading } = useFamilies();
  const { selectedFamily, setSelectedFamily } =
    React.useContext(NavigatorContext);
      
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 2,
    target: typeof window !== `undefined` && window ? window : undefined,
  });

  const handleChange = (
    _e: React.SyntheticEvent<Element, Event>,
    n: string
  ) => {
    setSelectedFamily(n);
  };

  return (
    <AppBar position="sticky">
      <Box>
        <Box alignItems="center" display="flex" flexDirection="column" pt={1}>
          <ResturantType trigger={trigger}>CERVECERIA·TAPAS</ResturantType>
          <ResturantName trigger={trigger}>D'Vero</ResturantName>
        </Box>
        <Slide direction="right" in mountOnEnter unmountOnExit timeout={1500}>
          <Tabs
            value={selectedFamily}
            onChange={handleChange}
            scrollButtons
            allowScrollButtonsMobile
            indicatorColor="secondary"
            textColor="inherit"
            variant="scrollable"
          >
            {!loading &&
              [AllFamilyItem, ...families].map((fam, index) => (
                <Tab key={index} value={fam.uuid} label={fam.name} />
              ))}
          </Tabs>
        </Slide>
      </Box>
    </AppBar>
  );
};

const ResturantName = styled.h1<{ trigger: boolean }>`
  font-family: 'Oleo Script Swash Caps', cursive;
  font-size: ${(props) => (props.trigger ? '3rem' : '6rem')};
  line-height: 0.9;
  font-weight: 500;
  margin: 0;
  transition: font-size ease-in 0.3s !important;
`;
const ResturantType = styled.h2<{ trigger: boolean }>`
  font-family: 'Roboto';
  font-size: ${(props) => (props.trigger ? '1rem' : '2rem')};
  font-weight: 500;
  margin: 0;
  transition: font-size ease-in 0.3s !important;
`;
